import { AccordionSummary, AccordionSummaryProps } from '@mui/material'
import { styled } from '@mui/system'
import { ArrowDownIcon } from './ArrowDownIcon'

export const ContentAccordionSummary = styled(
  (
    props: AccordionSummaryProps & { hasLines: boolean; isSmallScreen: boolean }
  ) => {
    return (
      <AccordionSummary
        expandIcon={<ArrowDownIcon fontSize='large' />}
        {...props}
      />
    )
  }
)(({ hasLines, isSmallScreen }) => ({
  padding: 0,
  minHeight: 'unset',
  cursor: hasLines ? 'pointer' : 'default',
  '& .MuiAccordionSummary-content': {
    margin: 0,
    padding: isSmallScreen ? '16px 23px' : '24px',
    borderRight: hasLines ? '2px solid #F2F2F2' : 'unset'
  },
  '& .Mui-expanded': {
    borderRight: 'unset'
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    padding: isSmallScreen ? '15px 18px' : '22px',
    display: hasLines ? 'flex' : 'none'
  }
}))
